// 承运商相关接口API
import axios from "./axios";
export default {
    // 推荐货源
    getStayOfferList(data) {
        return axios.post('/ythDemand/search', data)
    },
    // 报价单列表
    // getOfferOrderList(data) {
    //     return axios.post('/ythQuote/findList', data)
    // },
    // 报价单列表2.0
    getOfferOrderList(data) {
        return axios.post('/ythQuote/quoteList', data)
    },

    // 获取报价单详情
    // getOfferOrderDetails(data) {
    //     return axios.get('/ythDemand/detail/' + data)
    // },
    // 获取报价单详情2.0
    getOfferOrderDetails(data) {
        return axios({
            url: '/yth/inquiry/getInquiryDetail',
            method: 'get',
            params: data
        })
    },
    // 确认接单
    confirmOrder(data) {
        return axios.get('/ythQuote/quote/confirmOrder', { params: data })
    },
    // 拒绝货源
    cancelGoods(data) {
        return axios.get('/ythQuote/quote/refuse', { params: data })
    },
    // 承运商报价
    // submitOffer(data) {
    //     return axios.post('/ythQuote/offer/confirm', data)
    // },
    //承运商报价2.0
    submitOffer(data) {
        return axios.post('/ythQuote/offer/confirm', data)
    },
    // 取消报价
    cancelOffer(data) {
        return axios.get('/ythQuote/cancle/' + data, null)
    },
    // 报价单获取拒绝原因列表
    getOfferReject() {
        return axios.get('/ythQuote/refuseReasonList')
    },
    // 报价单中标确认确认接单
    orderWinningConfirm(data) {
        return axios.get('/ythQuote/quote/confirm', { params: data })
    },
    // 报价单中标拒绝接单
    orderWinningCancel(data) {
        return axios.post('/ythQuote/refuse', data)
    },
    // 物流单列表
    logisticsOrderList(data) {

        return axios.post('/ythQuote/logistics/findList', Object.assign(data,{clientSource:"PC"}))
    },
    // 更换委托单
    changeCarTransportQuote(data) {
        return axios.get('/net-work-freight-map/change/car-transport-quote',{ params: data })
    },
    // 物流单确认接单
    logisticsConfirmOrder(data) {
        return axios.get('/yth/consignmentNote/scheduling/confirm', {
            params: data
        })
    },
    // 获取运输货物类别列表
    getGoodsTypeList() {
        return axios.get('/dictionary/select/network_goods_type', null)
    },
    // 获取包材列表
    getPackageList(data) {
        return axios.post('/appPackage/getPackageList', data)
    },
    // 创建运单
    createTransportOrder(data) {
        return axios.post('/ythTransport/order/insert', data)
    },
    // 运单列表
    transportOrderList(data) {
        return axios.post('/ythTransport/findList', data)
    },
    // 运单列表详情
    transportOrderDetails(data) {
        return axios.get('/ythTransport/detail/' + data, null)
    },
    // 获取承运商的车辆列表
    getCarriersCarList(data) {
        return axios.post('/driver/carList/' + data.id, data.page)
    },
    //
    getAllCarList(data){
        return axios.post('/driver/carList/' + data.id, data.page)
    },
    // 获取当前车辆承运商下的所有司机
    getCarriersDriverList(data) {
        return axios.get('/driver/curCar/driverList', { params: data })
    },
    // 分配司机
    distributeDriverAndCar(data) {
        return axios.post('/ythTransport/distribute/driver', data)
    },
    // 新增承运组
    addTransportGroup(data) {
        return axios.post('/transport-group', data)
    },
    //查询承运组
    getTransportGroupList(data) {
        return axios.get('/transport-group/page-carrier', {params:data})
    },
    // 添加成员
    addTransportPoolMember(data){
        return axios.post(`/transport-pool`,data)
    },
    //查询成员
    getTransportPoolMemberList(data){
        return axios.get(`/transport-pool/page-carrier`,{params:data})
    },
    //
    getTransportPoolMapMemberList(data){
        return axios.get(`/transport-group-map/page-carrier`,{params:data})
    },
    // 删除成员
    delTransportPoolMember(data){
        return axios.delete(`/transport-pool/${data}`,)
    },
    // 删除
    delTransportGroup(pk){
        return axios.delete(`/transport-group/${pk}`)
    },
    //
    transportPoolByBO(data){
        return axios.post(`/transport-group-biz/transportPoolByBO`,data)
    },
    // 有效时间获取
    getValidTime() {
        return axios.get('/dictionary/getValidTime')
    },
    // 更换司机
    updateDriverAndCar(data) {
        return axios.post('/ythAdmin/ythTransport/changeDriver', data)
    },
    // 承运商关闭运单
    closeTransport(data) {
        return axios.get('/ythTransport/closeTransport', { params: data })
    },
    // 关闭危化品运单
    //
    closeDangerTransport(data) {
        return axios.get('/danger-car-transport-map/confirm/danger-car-fill-order', { params: data })
    },

    // 将运单推送至平台
    pushToPlatform(data) {
        return axios.post('/ythTransport/pushToPlatform', data)
    },
    // 获取回单信息
    getBackOrderInfo(data) {
        return axios.get('/ythTransport/getReturn/' + data, null)
    },
    // 确认回单
    confirmBackOrder(data) {
        return axios.post('/depend-ythTransport/confirmReceipt', data)
    },
    // 获取可结算运单
    getTransportForThe(data) {
        return axios.post('/delegate/common/liquidation', data)
    },
    // 承运商对平台发起结算
    reconciliationCarrier(data) {
        return axios.post('/reconciliation/carrier/with/carrier', data)
    },
    // 承运商对司机发起结算
    driverWithCarrier(data) {
        return axios.post('/reconciliation/driver/with/carrier', data)
    },
    // 车辆管理列表
    carManagementList(data) {
        return axios.post('/ythNfpCar/car/manager', data)
    },
    // 车辆管理列表-新接口
    getRegisterCarList(data) {
        return axios.get('/ythNfpCar/getRegisterCarList', { params: data })
    },
    //
    getCarInfo(carNumber){
        return axios.get(`/ythNfpCar/get-car-info/${carNumber}`, {})
    },
    //
    updateCarInfo(data){
        return axios.post(`/ythNfpCar/update-car-info`, data)
    },
    // 获取车辆详细信息
    getCarDetails(data) {
        return axios.get('/ythNfpCar/get', {
            params: data
        })
    },
    // 获取车辆详细信息-新接口
    getCarInfoById(data) {
        return axios.get('/ythNfpCar/getCarInfoById', { params: data })
    },
    // 司机管理列表
    driverManagementList(data) {
        return axios.post('/driver/relationshipDriver', data)
    },
    // 司机绑定申请列表
    driverBindingList(data) {
        return axios.post('/carrier/driverBindingList', data)
    },
    // 确认或拒绝司机绑定申请
    driverBindAction(data) {
        return axios.post('/carrier/driverBindAction', data)
    },
    // 导出
    exportDriver() {
        return axios({
            url: '/driver/exportDriver',
            method: 'get',
            responseType: 'blob'
        })
    },
    // 获取司机详细信息
    getDriverDetails(data) {
        return axios.get('/driver/driverInfo', {
            params: data
        })
    },
    // 承运商解绑司机
    unBindDriver(data) {
        return axios.get('/carrier/disInvite', {
            params: data
        })
    },
    // 承运商邀请司机
    invitationDriver(data) {
        return axios.post('/driver/invite', data)
    },
    // 承运商邀请司机列表-new
    driverinvite(data) {
        return axios.post('/driver/inviteDriver', data)
    },

    // 承运商为司机发起换绑申请
    driverChange(data) {
        return axios.post('/driver/change', data)
    },
    // 查询轮播图
    adminContentPage(data) {
        return axios.get('/adminContent/page', {
            params: data
        })
    },
    // 获取可抢单运单列表
    getGrabTransportList(data) {
        return axios.post('/ythTransport/getGrabTransportList', data)
    },
    // 社会车辆接单：获取当前司机的车辆
    getCarList(data) {
        return axios.post('/driver/getCarList/defaultDriver', data)
    },
    // 司机抢单提交
    grabTransportOrder(data) {
        return axios.post('/ythTransport/grabTransportOrder', data)
    },
    // 在线客服-查找问题
    adminMessageBoardSearch(data) {
        return axios.post('/adminMessageBoard/search', data)
    },
    // 在线客服-提问
    adminMessageBoardAskQuestions(data) {
        return axios.post('/adminMessageBoard/askQuestions', data)
    },
    // 投诉管理-我要投诉
    adviceComplaint(data) {
        return axios.post('/advice/complaint', data)
    },
    // 投诉管理-我要投诉-投诉列表
    adviceGetAdviceList(data) {
        return axios.post('/advice/getAdviceList', data)
    },
    //投诉管理-我要投诉-投诉列表-详情
    advicegetAdviceDetail(id) {
        return axios.get('/advice/getAdviceDetail/' + id,)
    },
    // 和我(承运商)发生过(签约)关系的司机
    driverRelationshipDriver(data) {
        return axios.post('/driver/relationshipDriver', data)
    },
    // 用户管理-司机与车辆捆版-绑定
    ythNfpCarBindApply(data) {
        return axios.post('/ythNfpCar/bindApply', data)
    },
    // 用户管理-司机与车辆捆版-解绑
    ythNfpCarUnBinding(data) {
        return axios.get('/ythNfpCar/unBinding', {
            params: data
        })
    },
    //承运商交易统计分析
    // carrierTradeStatistics() {
    //     return axios.get('/reportForm/carrierTradeStatistics')
    // },
    ythQuoteTradeStatistics(data) {
        return axios.post("/ythQuote/tradeStatistics", data);
    },
    // 物流单追踪
    carrierTrack(data) {
        return axios.post('/carrier/track', data)
    },
    // 绑定挂车：获取可绑定挂车列表
    canBoundTrailerCarList(data) {
        return axios.get('/ythNfpCar/canBoundTrailerCarList', {
            params: data
        })
    },
    // 绑定挂车： 捆绑挂车申请
    bindTrailer(data) {
        return axios.post('/ythNfpCar/bindTrailer', data)
    },
    // 绑定挂车：获取可绑定挂车列表
    unbindTrailer(data) {
        return axios.get('/ythNfpCar/unbindTrailer', {
            params: data
        })
    },
    // 报价管理：询比价、竞争谈判、邀标管理
    getInquiryList(data) {
        return axios.post('/yth/inquiry/list', data)
    },
    // 承运商：用户管理统计分析
    carriersStatistics(data) {
        return axios.post('/ythAdmin/ythCarrier/pcStatistics', data)
    },
    // 运单管理：统计分析-汇总报表(承运商)
    carrierTransportStatistics(data) {
        return axios.post('/reportForm/carrierTransportStatistics', data)
    },
    // 承运商运输线路统计
    carrierTransportRouteStatistics(data) {
        return axios.get("/reportForm/carrierTransportRouteStatistics", { params: data });
    },
    // 司机列表
    carrierDriverList(data) {
        return axios.post('/carrier/driverList', data)
    },
    // 承运商合同管理——执行追踪
    carrierContractTrack(data) {
        return axios.post('/contract/carrierContractTrack', data)
    },
    // 承运商运输线路统计
    carrierCertificateWarning() {
        return axios.get("/carrier/certificateWarning");
    },
    // 承运商：司机证件预警
    driverCertificateWaring(data) {
        return axios.post('/carrier/driverCertificateWaring', data)
    },
    // 承运商：车辆证件预警
    carCertificateWaring(data) {
        return axios.post('/carrier/carCertificateWaring', data)
    },
    // 承运商退出平台申请
    carrierApplyQuit(data) {
        return axios.get('/carrier/applyQuit', { params: data })
    },
    // 车辆统计分析
    carStatistics(data) {
        return axios.post('/carrierForm/carStatistics', data)
    },
    // 承运商/司机运输明细表
    transportationDetail(data) {
        return axios.post('/carrierForm/transportationDetail', data)
    },
    // 汽车运输明细导出
    exportTransportationDetail(data) {
        return axios.post('/carrierForm/transportationDetail-excel', data)
    },
    // 同步EWM数据
    refreshEwmQuantity(data){
        return axios.get('/net-work-to-ewm/refresh/ewm-quantity', data)
    },
    // 承运商交易统计分析
    carrierTransactionStatistics(data) {
        return axios.post('/carrierForm/transactionStatistics', data)
    },
    // 关闭平台委托单
    consignmentNoteColse(data) {
        return axios.get("/yth/consignmentNote/close", { params: data });
    },
    // 查询车辆过磅记录
    //
    balanceDataByCar(data){
        return axios.post("/wagon-balance-map/balance-data-by-car", data);
    },
    // 将地磅记录与运单匹配
    //
    matchTransportAndBalance(data){
        return axios.post("/wagon-balance-map/match-transport-and-balance", data);
    }
}
